import React from 'react';

import { TaxProfileForm } from './TaxProfileForm';
import { RetakeProfile } from './RetakeProfile';
import { TaxDocument } from './TaxDocument';
import { useSelector } from 'react-redux';
import { selectTaxProfileState, selectNoTaxProfile } from '../../selectors/tax.selector';
import { Loading } from '../common/Loading';

export const TaxProfile: React.FC = () => {
    const { loading } = useSelector(selectTaxProfileState);
    const noTaxProfile = useSelector(selectNoTaxProfile);

    if (loading) {
        return <Loading />;
    }
    return (
        <>
            <TaxDocument />
            <TaxProfileForm />
            {!noTaxProfile && (
                <>
                    <RetakeProfile />
                </>
            )}
        </>
    );
};
